import * as React from 'react';
import type { SVGProps } from 'react';

export const UnderConstructionCone = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={'100%'} height={'100%'} viewBox="0 0 315 324" fill="none" {...props}>
    <path
      fill="#FF5101"
      stroke="#000"
      strokeWidth={4}
      d="m304.488 221.263-74.086-23.744.432 1.57c2.402 8.725.284 18.197-5.995 24.7-9.355 9.684-28.664 20.46-68.287 20.46s-58.93-10.77-68.287-20.461c-6.278-6.503-8.396-15.974-5.994-24.7l2.444-8.867-74.69 31.268a14.54 14.54 0 0 0-5.115 4.923 14.58 14.58 0 0 0 3.517 19.307L151.54 318.32a14.52 14.52 0 0 0 17.113.374l137.409-72.56c8.976-6.248 8.113-19.804-1.574-24.871Z"
    />
    <path
      fill="#FF5100"
      stroke="#000"
      strokeWidth={4}
      d="M156.552 113.85c19.391 0 38.99-8.256 46.511-11.807q.478-.165.977-.243l-12.451-45.206a5.8 5.8 0 0 1-3.728 3.633l-4.301 1.346c-8.238 2.607-15.344 4.858-27.002 4.858-13.515 0-19.45-2.062-28.431-5.186l-3.072-1.06a5.85 5.85 0 0 1-3.552-3.555l-12.586 45.692q.625.113 1.213.356c13.651 7.207 30.137 11.172 46.422 11.172ZM128.876 48.972l3.125 1.08c8.675 3.016 13.024 4.528 24.545 4.528 9.835 0 15.539-1.808 23.433-4.31l4.432-1.38a5.78 5.78 0 0 1 5.362 1.126l-3.638-13.218c-2.835-9.003-5.835-16.05-8.788-21.569-8.964-16.732-33.316-16.72-42.061.13-2.859 5.5-5.705 12.512-8.328 21.444l-3.638 13.241a5.81 5.81 0 0 1 5.556-1.072Z"
    />
    <path
      fill="#FF5100"
      stroke="#000"
      strokeWidth={4}
      d="M158.653 179.049c27.865 0 48.54-11.249 57.777-20.886a5.8 5.8 0 0 1 2.722-1.512l-11.97-43.465c-8.776 4.066-29.528 12.519-50.624 12.519-17.728 0-35.688-4.267-50.777-11.973l-11.545 41.923a5.76 5.76 0 0 1 3.142 1.997c9.835 12.797 34.463 21.397 61.275 21.397Z"
    />
    <path
      fill="#FF5100"
      stroke="#000"
      strokeWidth={4}
      d="m230.839 199.089-8.373-30.399c-12.077 11.13-34.309 22.214-63.814 22.214-28.611 0-54.577-8.838-67.85-22.784l-8.532 30.975c-2.403 8.725-.284 18.197 5.994 24.7 9.356 9.684 28.664 20.46 68.287 20.46s58.931-10.769 68.287-20.46c6.285-6.509 8.404-15.981 6.001-24.706Z"
    />
    <path
      fill="#EDEDED"
      stroke="#000"
      strokeWidth={4}
      d="m222.466 168.689-5.169-18.787c-.994.273-.098.711-.867 1.511-9.237 9.638-29.914 20.887-57.778 20.887-26.806 0-51.434-8.6-61.275-21.397-.81-1.061-.241-.675-1.442-1.002l-5.133 18.219c13.273 13.947 39.245 22.784 67.849 22.784 29.5 0 51.738-11.084 63.815-22.215ZM208.893 120.026l-4.847-18.226q-.5.073-.977.243c-7.521 3.551-27.118 11.807-46.511 11.807-16.285 0-32.771-3.965-46.421-11.173a5.6 5.6 0 0 0-1.213-.355l-4.777 17.704c15.089 7.712 34.683 12.427 52.411 12.427 21.09 0 43.554-8.356 52.335-12.427ZM128.125 67.995c8.983 3.118 14.918 5.187 28.432 5.187 11.663 0 18.77-2.253 27.001-4.86 6.142-1.908 9.289-3.312 9.911-4.984l-3.685-13.328a5.79 5.79 0 0 0-5.362-1.127l-4.43 1.381c-7.894 2.501-13.598 4.309-23.433 4.309-11.521 0-15.876-1.511-24.545-4.528l-3.125-1.08a5.82 5.82 0 0 0-5.563 1.073l-3.656 13.299z"
    />
    <path
      fill="#E73C00"
      stroke="#000"
      strokeWidth={4}
      d="M84.709 190.222 10.22 221.405l141.545 67.434a21.77 21.77 0 0 0 21.232-.314l131.633-67.162a2 2 0 0 0-.148-.101l-74.086-23.744.432 1.571c2.402 8.725.283 18.196-5.995 24.7-9.355 9.684-28.664 20.46-68.287 20.46s-58.931-10.77-68.287-20.46c-6.278-6.503-8.397-15.974-5.994-24.7z"
    />
  </svg>
);
